{
  document.addEventListener("DOMContentLoaded", function () {
    const container = document.querySelector(".logo_rows");
    if (!container) return;
    const boxes = Array.from(container.querySelectorAll(".LOGO_WRP"));
    const CLONE_COUNT = 3;
    for (let i = 0; i < CLONE_COUNT; i++) {
      boxes.forEach((box) => {
        container.appendChild(box.cloneNode(true));
      });
    }
    const scrollDistance = container.scrollWidth / 2;
    const SPEED = 60;
    const duration = scrollDistance / SPEED;
    const animation = gsap.to(container, {
      x: -scrollDistance,
      duration: duration,
      ease: "linear",
      repeat: -1,
    });
    container.addEventListener("mouseenter", () => animation.pause());
    container.addEventListener("mouseleave", () => animation.resume());
  });
}

{
  document.addEventListener("DOMContentLoaded", function () {
    const videoBoxes = document.querySelectorAll(".video__box");
    videoBoxes.forEach((box) => {
      const video = box.querySelector("video");
      const playIcon = box.querySelector(".play-btn-hldr");
      box.addEventListener("click", () => {
        document
          .querySelectorAll(".video__box video")
          .forEach((v) => v !== video && v.pause());
        video[video.paused ? "play" : "pause"]();
        playIcon.style.display = video.paused ? "flex" : "none";
      });
      video.addEventListener("play", () => (playIcon.style.display = "none"));
      video.addEventListener("pause", () => (playIcon.style.display = "flex"));
    });
  });
}

{
  document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll(".reize_icon").forEach((icon) => {
    icon.addEventListener("click", function () {
      const video = icon.closest(".video-media").querySelector("video");
      video.requestFullscreen
        ? video.requestFullscreen()
        : video.webkitRequestFullscreen
        ? video.webkitRequestFullscreen()
        : video.msRequestFullscreen && video.msRequestFullscreen(),
        video.play();
    });
  });
});
}

{
  document.addEventListener("DOMContentLoaded", function () {
    const allAccordions = document.querySelectorAll(
      ".faqs__rows .accordion_cus"
    );
    allAccordions.forEach((accordion) => {
      const items = accordion.querySelectorAll(".faqs__rows .acco_cus_item");
      if (items.length > 0) {
        items[0].classList.add("open");
      }
      items.forEach((item) => {
        const header = item.querySelector(".faqs__rows .acc-header");
        header.addEventListener("click", () => {
          items.forEach((otherItem) => {
            if (otherItem !== item && otherItem.classList.contains("open")) {
              otherItem.classList.remove("open");
            }
          });
          item.classList.toggle("open");
        });
      });
    });
  });
}


document.addEventListener("DOMContentLoaded", function () {
  const preloader = document.querySelector(".preloder__cus");
  const logo = document.querySelector(".preloder__element img");
  setTimeout(() => {
    preloader.style.opacity = "0";
    preloader.style.transition = "0.5s ease";
    setTimeout(() => {
      preloader.style.display = "none";
      logo.classList.add("logo-rotate");
    }, 500);
  }, 500);
});


// Product Quantity updater

document.addEventListener('DOMContentLoaded', () => {

    const qtyInput = document.querySelector('.product__info-container .quantity__input');
    const quantityParant = document.querySelector('.product-form__quantity');
    const options = document.querySelectorAll('.feild_verint_box input[type="radio"]');
    // let oneTimeCrossPrice = document.querySelector('.sls-one-time-price .sls-original-price span');
    // let oneTimePrice = document.querySelector('.sls-one-time-price .sls-price>span');


    if (!qtyInput || !options.length) return;

    const qtyMap = {
        'Buy 1 Get 1 Free': 2,
        'Buy 2 Get 2 Free': 4,
        'Buy 3 Get 3 Free': 6
    };

    const setQty = value => qtyMap[value] && (qtyInput.value = qtyMap[value]);

    setQty(document.querySelector('.feild_verint_box input[type="radio"]:checked')?.value);

    const observer = new MutationObserver(() => {
        setQty(document.querySelector('.feild_verint_box input[type="radio"]:checked')?.value);
    });
    
    observer.observe(quantityParant, {
        childList: true,
        subtree: true
    });

    options.forEach(opt =>
        opt.addEventListener('change', e => {
          
          setQty(e.target.value)
          // console.log(e.target.parentElement.parentElement);

          
          // const parent_holder = e.target.parentElement.parentElement; 
          // let AfterDiscountPrice = parent_holder.querySelector('.prices__area span').innerText;
          // let OrginalPrice = parent_holder.querySelector('.prices__area s').innerText;

          // if(AfterDiscountPrice && OrginalPrice){
          //    oneTimeCrossPrice = document.querySelector('.sls-one-time-price .sls-original-price span');
          //    oneTimePrice = document.querySelector('.sls-one-time-price .sls-price>span');

          //    if(oneTimeCrossPrice || oneTimePrice){
          //       oneTimeCrossPrice.innerText = OrginalPrice;
          //       oneTimePrice.innerText = AfterDiscountPrice;
          //    }

          // }

        })
    );




});


{
    document.addEventListener("DOMContentLoaded", function () {
      const items = document.querySelectorAll(".product_acco_cus_item");
      items.forEach((item) => {
        item.addEventListener("click", () => {
          if (item.classList.contains("open")) {
            item.classList.remove("open");
          } else {
            items.forEach((el) => el.classList.remove("open"));
            item.classList.add("open");
          }
        });
      });
    });
}